// src/components/Auth/ResetPassword.js
import React, { useState } from 'react';
import { AuthContainer, AuthBox, InputField, Button, Title, ErrorMessage } from '../../styles/AuthStyles';
import { useNavigate, useLocation } from 'react-router-dom'; // Updated imports
import axios from 'axios';
import { API_BASE_URL } from '../../config/config';

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate(); // Updated hook
  const location = useLocation(); // To retrieve state
  
  const { userId } = location.state || {}; // Retrieve userId from state

  const handleResetPassword = async () => {
    setError('');

    if (!newPassword || !confirmPassword) {
      setError('Please fill in all fields.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    
    try {
      const response = await axios.post(`${API_BASE_URL}api/users/reset-password`, { userId, newPassword, confirmPassword });
      if (response.data.message) {
        // Navigate to Success screen
        navigate('/success');
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message);
      } else {
        setError('An unexpected error occurred. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  // Redirect if userId is not present
  if (!userId) {
    navigate('/forgot-password');
    return null;
  }

  return (
    <AuthContainer>
      <AuthBox>
        <Title>Reset Password</Title>
        {error && <ErrorMessage>{error}</ErrorMessage>}
        <InputField
          type="password"
          placeholder="New Password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <InputField
          type="password"
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        <Button onClick={handleResetPassword} disabled={loading}>
          {loading ? 'Resetting...' : 'Reset Password'}
        </Button>
      </AuthBox>
    </AuthContainer>
  );
};

export default ResetPassword;
